import { useAppSelector } from 'redux/toolkit/hooks'
import { Auth } from 'v2/modules/lib/utils/auth'

export const useDomainPolicyAccess = (domainId: number) => {
  const authDomainPolicies = useAppSelector(_store => _store.auth.accessTokenObject?.authDomainPolicies || [])

  const auth = Auth(authDomainPolicies)
  const canManageDomainPolicies = auth.canManageDomainPolicies(domainId)
  const canReadDomainPolicies = auth.canReadDomainPolicies(domainId)
  const canViewDomainMessages = auth.canViewDomainMessages(domainId)

  const hasNoDomainPolicyAccess = !canManageDomainPolicies && !canReadDomainPolicies
  const canAccessDomainPolicies = canReadDomainPolicies || canManageDomainPolicies

  return {
    hasNoDomainPolicyAccess,
    canAccessDomainPolicies,
    canManageDomainPolicies,
    canReadDomainPolicies,
    canViewDomainMessages
  }
}
